module.exports = __webpack_public_path__ + "img/lr.svg";